export default __webpack_public_path__ + "static/media/artwork-card-1.d8f3c331.png";